// extracted by mini-css-extract-plugin
export default {"title":"PaymentToWholesalerDetails_title__CYLHP","total":"PaymentToWholesalerDetails_total__XB0F7","edit":"PaymentToWholesalerDetails_edit__-J9xU"};